import styled from "styled-components";

export const Container = styled.div`
  margin: 30px;
  align-items: stretch;

  strong {
    font-weight: bold;
  }
`;

export const Div = styled.div<{ show?: boolean }>`
  display: ${props => props.show ? 'block' : 'none'};
  align-items: stretch;
`;

export const Content = styled.div<{ show?: boolean }>`
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;

  h1, h2, h3, h4, h5 {
    margin-bottom: 10px;
  }

  span {
    display: flex;
    margin-bottom: 5px;
  }

  fieldset {
    text-align: left;
  }

  form {
    margin: 10px 0;
    width: 350px;
    text-align: center;

    label {
      display: flex;
      margin-bottom: 5px;
    }

    a {
      color: #004070;
      text-decoration: none;
      transition: color 0.2s;
    }
  }
`;